import merge from "deepmerge";
import { WINDOWSTATE } from "../../../../common/constants";
import { ComponentConfig } from "../types";

const DEFAULT_WINDOW_DESCRIPTOR = {
	alias: "",
	path: "",
	arguments: "",
	autoShow: true,
	backgroundColor: "#151f28",
	alwaysOnTop: false,
	fixedPosition: false,
	frame: false,
	frameConnect: "",
	hoverFocus: false,
	defaultCentered: false,
	maxHeight: Infinity,
	maximizable: true,
	maxWidth: -1,
	minHeight: 0,
	minimizable: true,
	minWidth: 0,
	opacity: 1,
	resizable: true,
	contextMenu: true,
	resizeRegion: {
		size: 5,
		bottomCorner: 10,
	},
	saveWindowState: false,
	showTaskbarIcon: true,
	state: "normal",
	windowState: WINDOWSTATE.NORMAL,
	waitForPageLoad: false,
	// so that child-apps inherit taskbar icon from the main application. This prevents apps (eg, symphony) from showing up as the taskbar icon.
	icon: null,
	customData: {
		component: {
			type: "",
			canMinimize: true,
			canMaximize: true,
		},
		foreign: {
			services: {
				launcherService: {
					inject: false,
				},
			},
			components: {
				"App Launcher": {
					launchableByUser: true,
				},
				"Window Manager": {
					persistWindowState: true,
					FSBLHeader: true,
				},
			},
		},
	},
};

const DEFAULT_CHILD_WINDOW_OPTIONS = {
	window: {
		addToWorkspace: false,
		componentType: "window-open",
	},
	component: {
		type: "window-open",
		isUserDefined: true,
	},
	foreign: {
		components: {
			"App Launcher": {
				launchableByUser: false,
			},
			"Window Manager": {
				FSBLHeader: true,
				title: "",
			},
		},
		services: {
			windowService: {
				allowGrouping: false,
				allowSnapping: true,
				allowTabbing: false,
				allowTiling: false,
				manageWindowMovement: true,
			},
		},
	},
};

export default function LauncherDefaults(this: any) {
	// We must provide a clean slate of properties otherwise new windows will spawn with the same
	// properties as the main window (from the manifest). Here we set reasonable defaults
	// for every window. We allow some properties to carry through from the manifest (such as cornerRounding).
	//
	// A developer can then override any of *these* values by specifying an "options" entry in the component
	// config, or by passing an "options" argument to spawn().
	this.windowDescriptor = {
		...DEFAULT_WINDOW_DESCRIPTOR,
		childWindowOptions: merge(DEFAULT_WINDOW_DESCRIPTOR, DEFAULT_CHILD_WINDOW_OPTIONS),
	};
	// A default manifest
	this.componentDescriptor = {
		window: {
			//url: "about:blank",
			frame: false,
			resizable: true,
			autoShow: true,
			top: "center",
			left: "center",
			width: 400,
			height: 432,
			addToWorkspace: true,
		},
		component: {
			inject: false,
			spawnOnStartup: false,
		},
		foreign: {
			services: {
				dockingService: {
					canGroup: true,
				},
			},
			components: {
				"App Launcher": {
					launchableByUser: true,
				},
				"Window Manager": {
					FSBLHeader: true,
					persistWindowState: true,
					title: "Welcome",
				},
			},
		},
	};
}

export const UNKNOWN_DEFAULT_CONFIG: ComponentConfig = {
	window: {
		//url: "about:blank",
		frame: false,
		resizable: true,
		autoShow: true,
		top: "center",
		left: "center",
		width: 400,
		height: 432,
		addToWorkspace: true,
	},
	component: {
		inject: false,
		spawnOnStartup: false,
	},
	components: {},
	foreign: {
		services: {
			dockingService: {
				canGroup: true,
			},
		},
		components: {
			"App Launcher": {
				launchableByUser: true,
			},
			"Window Manager": {
				FSBLHeader: true,
				persistWindowState: true,
			},
		},
	},
};
